<template>
  <van-tabs
    v-model="active"
    sticky>
    <van-tab title="普通放射诊断">
      <DoctorList category="普通放射诊断"/>
    </van-tab>
    <van-tab title="CT诊断">
      <DoctorList category="CT诊断"/>
    </van-tab>
    <van-tab title="核磁共振诊断">
      <DoctorList category="核磁共振诊断"/>
    </van-tab>
  </van-tabs>
</template>

<script>
import DoctorList from './components/DoctorList.vue';

export default {
  name: 'Doctor',
  components: {
    DoctorList,
  },
  data() {
    return {
      active: '',
    };
  },
  watch: {
    active() {
      sessionStorage.setItem('report-type', this.active);
    },
  },
  activated() {
    this.active = 0;
  },
  mounted() {
    this.active = 0;
  },
};
</script>
